import React, { Component } from "react"
import { connect } from "react-redux"
import { Field, reduxForm } from "redux-form"
import cs from 'classnames'
import WizardModalContent from "./shared/WizardModalContent"
import styles from './ClaimWizard.scss'
import i18n from 'lib/i18n'
import { disableRiskAndQualificationFields, updatedFormValue } from "./claimsWizardService"
import { CreatableSelectWrapper } from "./shared/WizardSelects/WizardReactSelect"
import { DatePicker } from 'components/shared/datePicker'
import WizardButtons from "./shared/WizardButtons/WizardButtons"


// variables out of module
const _ = i18n('claimWizard')


export default class ClaimWizardStepTwo extends Component {

    renderParty(party, key) {
        const { onRemoveOptionalParty, updatePartyField, optionalInvPartyOptions, countryOptionsList, zipCodeOptions, mandatoryInvPartyOptions } = this.props

        return (
            <div className={styles.sectionWrapper} key={key + party.id} >
                <div className={styles.formInputContainer} >
                    <label className={cs(styles.formLabel, styles.maxWidthStepTwoLeft)}>{_('partyNumber')} </label>
                    <div className={cs(styles.formInput, styles.inputsForceRow)}>
                        <div className={cs(styles.formInput, styles.formInputCreatableSelect,
                            styles.sizeXS, styles.first, styles.dropdownWidth)}>
                            <CreatableSelectWrapper
                                type="text"
                                value={party.partyNumber}
                                options={party.isMandatory ? mandatoryInvPartyOptions : optionalInvPartyOptions}
                                onChange={(value) => updatePartyField(value ? value.value : '', party.id, 'partyNumber')}
                                formatCreateLabel={_('optionalPartyNumber')}
                                name="optionalPartyNumber"
                                isClearable
                                isDisabled={party.isMandatory}
                                isCreatableSelect={false}
                            />
                        </div>
                        <div className={cs(styles.formLabel, styles.marginLeftS, styles.short1)}></div>
                        <div className={cs(styles.formInput, styles.formInputCreatableSelect, styles.sizeXS, styles.shortMargin, styles.last, styles.removePartyWrapper)}>
                            {!party.isMandatory &&
                                <button
                                    type="button"
                                    className={styles.removePartyBtn}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        onRemoveOptionalParty(party.id)
                                    }}
                                >
                                    {_('removeParty')}
                                </button>
                            }
                        </div>
                    </div>
                </div>

                <div className={styles.formInputContainer} >
                    <label className={cs(styles.formLabel, styles.maxWidthStepTwoLeft)}>{`${_('firstName')} ${party.fields.firstName.required ? '*' : ''}`}</label>
                    <div className={cs(styles.formInput, styles.inputsForceRow)}>
                        <div className={cs(styles.formInput, styles.formInputCreatableSelect,
                            styles.sizeXS, styles.first)}>
                            <input
                                className={cs(styles.formInput, styles.formInputText)}
                                type="text"
                                name="invPartyFirstName"
                                value={party.fields.firstName.value}
                                onChange={(e) => {
                                    updatePartyField(e.target.value, party.id, 'firstName')
                                }}
                            />
                        </div>
                        <div className={cs(styles.formLabel, styles.marginLeftS, styles.short1, styles.maxWidthStepTwoRight)}>
                            {`${_('lastName')} ${party.fields.lastName.required ? '*' : ''}`}
                        </div>
                        <div className={cs(styles.formInput, styles.formInputCreatableSelect, styles.sizeXS, styles.shortMargin, styles.last)}>
                            <input
                                className={cs(styles.formInput, styles.formInputText)}
                                type="text"
                                name="invPartyLastName"
                                value={party.fields.lastName.value}
                                onChange={(e) => updatePartyField(e.target.value, party.id, 'lastName')}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.formInputContainer} >

                    <label className={cs(styles.formLabel, styles.maxWidthStepTwoLeft)}>{`${_('street')} ${party.fields.street.required ? '*' : ''}`} </label>
                    <div className={cs(styles.formInput, styles.inputsForceRow)}>
                        <div className={cs(styles.formInput, styles.formInputCreatableSelect, styles.sizeXS, styles.first)}>
                            <input
                                className={cs(styles.formInput, styles.formInputText)}
                                type="text"
                                ref=""
                                name="invPartyStreet"
                                value={party.fields.street.value}
                                onChange={(e) => updatePartyField(e.target.value, party.id, 'street')}
                            />
                        </div>
                        <div className={cs(styles.formLabel, styles.marginLeftS, styles.short1, styles.maxWidthStepTwoRight)}>
                            {`${_('number')} ${party.fields.number.required ? '*' : ''}`}
                        </div>
                        <div className={cs(styles.formInput, styles.formInputCreatableSelect, styles.shortMargin, styles.sizeXS, styles.last)}>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect, styles.sizeXS, styles.first)}>
                                <input
                                    className={cs(styles.formInput, styles.formInputText)}
                                    type="text"
                                    ref="invPartyHouseNumber"
                                    name="invPartyHouseNumber"
                                    value={party.fields.number.value}
                                    onChange={(e) => updatePartyField(e.target.value, party.id, 'number')}
                                />
                            </div>
                            <div className={cs(styles.formLabel, styles.marginLeftS, styles.short1, styles.maxWidthStepTwoRight)}>{_('box')}</div>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect, styles.sizeExtraSmall, styles.last, styles.boxMinWidth)}>
                                <input
                                    className={cs(styles.formInput, styles.formInputText)}
                                    type="text"
                                    ref="invPartyBox"
                                    name="invPartyBox"
                                    value={party.fields.box.value}
                                    onChange={(e) => updatePartyField(e.target.value, party.id, 'box')}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {party.fields.country.value === '1' ?

                    <div className={styles.formInputContainer} >
                        <label className={cs(styles.formLabel, styles.maxWidthStepTwoLeft)}>{`${_('locality')} ${party.fields.postalCode.required ? '*' : ''}`} </label>
                        <div className={cs(styles.formInput, styles.inputsForceRow)}>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect,
                                styles.sizeXS, styles.first)}>
                                <CreatableSelectWrapper
                                    type="text"
                                    value={party.fields.postalCode.value && party.fields.town.value ? party.fields.postalCode.value + '_' + party.fields.town.value : ''}
                                    options={zipCodeOptions}
                                    onChange={(value) => {
                                        const splitValue = value.value.split('_')

                                        const zipCode = splitValue[0]
                                        const town = splitValue[1]
                                        updatePartyField(zipCode ? zipCode : '', party.id, 'postalCode')
                                        updatePartyField(town ? town : '', party.id, 'town')
                                    }}
                                    formatCreateLabel={_('invPartyPostalCodeAndTown')}
                                    name="invPartyPostalCodeAndTown"
                                    isClearable
                                    isCreatableSelect={false}
                                />
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.formInputContainer} >
                        <label className={cs(styles.formLabel, styles.maxWidthStepTwoLeft)}>{`${_('postalCode')} ${party.fields.postalCode.required ? '*' : ''}`} </label>
                        <div className={cs(styles.formInput, styles.inputsForceRow)}>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect,
                                styles.sizeXS, styles.first)}>
                                <input
                                    className={cs(styles.formInput, styles.formInputText)}
                                    type="text"
                                    ref="invPartyPostalCode"
                                    name="invPartyPostalCode"
                                    value={party.fields.postalCode.value}
                                    onChange={(e) => updatePartyField(e.target.value, party.id, 'postalCode')}

                                />
                            </div>
                            <div className={cs(styles.formLabel, styles.marginLeftS, styles.short1, styles.maxWidthStepTwoRight)}>{`${_('town')} ${party.fields.town.required ? '*' : ''}`}</div>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect, styles.sizeXS, styles.shortMargin, styles.last)}>
                                <input
                                    className={cs(styles.formInput, styles.formInputText)}
                                    type="text"
                                    ref="invPartyTown"
                                    name="invPartyTown"
                                    value={party.fields.town.value}
                                    onChange={(e) => updatePartyField(e.target.value, party.id, 'town')}
                                />
                            </div>
                        </div>
                    </div>
                }

                <div className={styles.formInputContainer} >
                    <label className={cs(styles.formLabel, styles.maxWidthStepTwoLeft)}>{`${_('country')} ${party.fields.country.required ? '*' : ''}`} </label>
                    <div className={cs(styles.formInput, styles.inputsForceRow)}>
                        <div className={cs(styles.formInput, styles.formInputCreatableSelect,
                            styles.sizeXS, styles.first, styles.dropdownWidth)}>

                            {/* if is mandatory party, number is fixed => input disable, if is optional party dropdown with list of parties */}
                            <CreatableSelectWrapper
                                type="text"
                                value={party.fields.country.value}
                                options={countryOptionsList}
                                onChange={(value) => updatePartyField(value ? value.value : '', party.id, 'country')}
                                formatCreateLabel={_('invPartyCountry')}
                                name="invPartyCountry"
                                isClearable
                                isCreatableSelect={false}
                            />
                        </div>
                        <div className={cs(styles.formLabel, styles.marginLeftS, styles.short1)}></div>
                        <div className={cs(styles.formInput, styles.formInputCreatableSelect, styles.sizeXS, styles.shortMargin, styles.last)}>
                        </div>
                    </div>
                </div>

                <div className={styles.formInputContainer} >

                    <label className={cs(styles.formLabel, styles.maxWidthStepTwoLeft)}>{`${_('phoneNumber')} ${party.fields.phoneNumber.required ? '*' : ''}`} </label>
                    <div className={cs(styles.formInput, styles.inputsForceRow)}>
                        <div className={cs(styles.formInput, styles.formInputCreatableSelect,
                            styles.sizeXS, styles.first)}>
                            <input
                                className={cs(styles.formInput, styles.formInputText)}
                                type="text"
                                ref=""
                                name="invPartyPhoneNumber"
                                value={party.fields.phoneNumber.value}
                                onChange={(e) => updatePartyField(e.target.value, party.id, 'phoneNumber')}
                            />
                        </div>
                        <div className={cs(styles.formLabel, styles.marginLeftS, styles.short1, styles.maxWidthStepTwoRight)}>{`${_('email')} ${party.fields.email.required ? '*' : ''}`}</div>
                        <div className={cs(styles.formInput, styles.formInputCreatableSelect, styles.sizeXS, styles.shortMargin, styles.last)}>
                            <input
                                className={cs(styles.formInput, styles.formInputText)}
                                type="text"
                                ref=""
                                name="invPartyEmail"
                                value={party.fields.email.value}
                                onChange={(e) => updatePartyField(e.target.value, party.id, 'email')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    render() {
        const { involvedPartiesData, onAddOptionalParty } = this.props
        const renderMandatoryParties = involvedPartiesData
            ? involvedPartiesData
                .filter(oneParty => oneParty.isMandatory)
                .map((oneParty, key) => this.renderParty(oneParty, key))
            : [];

        const isPartyNumberSelected = involvedPartiesData.every(
            (party) =>
                party.isMandatory ||
                (party.partyNumber && party.partyNumber.trim() !== "")
        )

        return (
            <WizardModalContent modalTitle={_('stepTwoTitle')}>

                <form method="post" onSubmit={(ev) => ev.preventDefault()} className={styles.modalFormContent} key={"claimWizardStepTwoForm"}>
                    {/* render mandatory parties */}
                    {renderMandatoryParties.length > 0 ? renderMandatoryParties :
                        <div className={styles.formInputContainer} >
                            <label className={styles.formLabel}>{_('missingMandatoryParties')} </label>
                        </div>
                    }
                    <div className={styles.formSeparator}></div>

                    {involvedPartiesData && involvedPartiesData.map((oneParty, key) => {
                        if (!oneParty.isMandatory) {
                            return this.renderParty(oneParty, key)
                        }
                    })
                    }
                    <WizardButtons
                        nextBtn={{
                            method: () => {
                                onAddOptionalParty()
                            },
                            disabled: !isPartyNumberSelected,
                            label: '+'
                        }}
                    />
                    {this.props.children}
                </form>
            </WizardModalContent >
        )
    }
}


// WEBPACK FOOTER //
// ./components/ClaimsWizard/ClaimWizardStepTwo.jsx